import { Grid } from '@material-ui/core';
import ActionBar from 'components/ActionBar/ActionBar';
import KeepaLayout from 'components/Layout';
import Card from './Componnets/Card';
import Status from 'components/Status';
import { CloseCircle } from 'iconsax-react';
import InvoiceType from './Componnets/InvoiceType';
import Outline from 'components/Button/Outline';
import Contained from 'components/Button/Contained';

const PaymentInvoice = ({ faild }) => {
	const handleGoBack = () => {};

	return (
		<KeepaLayout
			buttonComponent={
				<Grid container style={{ display: 'flex', justifyContent: 'space-between' }} spacing={2}>
					{faild && (
						<Grid xs={6} item>
							<Outline>ویرایش اقساط</Outline>
						</Grid>
					)}

					<Grid xs={faild ? 6 : 12} item>
						<Contained>{faild ? 'پرداخت مجدد ' : 'بازگشت به صفحه اصلی'}</Contained>
					</Grid>
				</Grid>
			}
			actionBar={
				<ActionBar
					title=" فاکتور پرداخت "
					arrow="icon-arrowflow-right"
					isDark
					divider
					onClick={handleGoBack}
				/>
			}
		>
			<Grid container>
				<Grid item xs={12} style={{ marginTop: '16px' }}>
					<Status
						icon={<CloseCircle size={25} color={'#EE3863'} variant="Bulk" />}
						faild
						message={'اقساط شما با موفقیت پرداخت شد'}
					/>
				</Grid>
				<Grid item xs={12} style={{ marginTop: '16px' }}>
					<Card title={'دوره های معوق پرداخت شده'} />
				</Grid>
				<Grid item xs={12} style={{ marginTop: '16px' }}>
					<Card title={'دوره جاری پرداخت شده'} />
				</Grid>
				<Grid item xs={12} style={{ marginTop: '16px' }}>
					<InvoiceType falid />
				</Grid>
			</Grid>
		</KeepaLayout>
	);
};

export default PaymentInvoice;
